import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, AlertTriangle } from "lucide-react";
import { PageHeader, StatusBadge } from "@/components/admin/common";
import { QrStudio } from "@/components/qr/QrStudio";
import { api } from "@/lib/api";

export default function QrPage() {
  const { id } = useParams();
  const [card, setCard] = useState(null);
  useEffect(() => {
    api.get(`/cards/${id}`).then((r) => setCard(r.data));
  }, [id]);
  if (!card) return <div className="eyebrow">Caricamento…</div>;
  return (
    <div>
      <Link to={`/admin/card/${id}/editor`} className="mb-6 inline-flex items-center gap-1.5 text-sm text-zinc-500 hover:text-zinc-900" data-testid="qr-back-editor"><ArrowLeft className="h-4 w-4" />Torna all'editor</Link>
      <PageHeader eyebrow={`QR code · ${card.client?.name}`} title={card.name}><StatusBadge status={card.status} /></PageHeader>
      {card.status !== "published" && (
        <div className="mb-6 flex gap-2 rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800" data-testid="qr-not-published-warning">
          <AlertTriangle className="h-4 w-4 shrink-0" />La card non è pubblicata: il QR è già definitivo, ma la pagina sarà visibile solo dopo la pubblicazione.
        </div>
      )}
      <QrStudio card={card} />
    </div>
  );
}
